import React, { Component } from 'react'
import routes from '../../routing/routes'
import { Col, Form, FormControl, FormGroup, Row } from 'react-bootstrap'
import injectSheet from 'react-jss'
import Marqueur from '../svg/Marqueur'
import ButtonStyle from '../button/ButtonStyle'
import { withRouter } from 'react-router'
import gql from 'graphql-tag'
import { graphql } from 'react-apollo'
import Filtre from '../svg/Filtre'
import Select from 'react-select'
import Async from 'react-select/async'
import { boundsFranceStringified, categoriesOptions } from 'src/config/dataConf'
import * as qs from 'query-string'
import {
  encodeBase64,
  fetchAddressAutocomplete,
  getUrlValueFromValue,
  getValueFromUrlValue
} from 'src/utils'
// eslint-disable-next-line camelcase
import { preg_quote } from 'locutus/php/pcre'

const styles = theme => ({
  marqueur: {
    padding: 6
  },
  form: {
    paddingBottom: '15px',
    marginTop: '35px'
  },
  formGroup: {
    margin: '0 auto 15px',
    width: '60%',
    '& select': {
      paddingLeft: '4.5px',
      paddingRight: '4.5px',
      borderRadius: 0
    }
  },
  divButton: {
    display: 'inline-block',
    verticalAlign: 'middle'
  },
  button: {
    padding: '3px',
    '&:hover': {
      borderColor: theme.button.backgroundColor
    }
  },
  rawRes: {
    backgroundColor: 'white'
  },
  texteResultats: {
    fontWeight: theme.regular,
    fontSize: theme.tailleMoyenTexte,
    color: theme.lien,
    marginTop: '10px'
  },
  divFiltre: {
    position: 'relative'
  },
  filtre: {
    position: 'absolute',
    top: 10,
    left: 10,
    zIndex: 1,
    '&:hover': {
      cursor: 'pointer'
    }
  },
  categories: {
    '& .categories__control': {
      width: '100%',
      marginRight: 15,
      border: theme.borderInput,
      borderRadius: 0,
      minHeight: 38,
      height: 38,
      '&:hover': {
        cursor: 'pointer'
      }
    },
    '& .categories__menu': {
      zIndex: 3
    }
  },
  autocomplete: {
    '& .address__control': {
      '& .address__input input': {
        maxWidth: 290
      },
      '& .address__placeholder': {
        paddingRight: 40
      },
      border: theme.borderInput,
      borderRadius: 0,
      '&:hover': {
        cursor: 'pointer'
      }
    }
  }
})

class SearchBarMobile extends Component {
  constructor(props) {
    super(props)
    const category = getValueFromUrlValue(
      qs.parse(this.props.location.search).category
    )
    let search = null
    if (category) {
      for (let i = 0; i < categoriesOptions.length; i++) {
        if (categoriesOptions[i].value === category) {
          search = categoriesOptions[i]
        }
      }

      if (search) {
        this.state = {
          query: '',
          category: search,
          showSearchBar: false
        }
      }
    }

    if (!category || !search) {
      this.state = {
        query: '',
        category: categoriesOptions[0],
        showSearchBar: false
      }
    }
  }

  getOptions = input => {
    const {
      data: { regions, loading }
    } = this.props
    const escapedInput = preg_quote(input)
    const regionsFiltered = !loading
      ? regions.filter(region =>
          region.name.toLowerCase().match(new RegExp(escapedInput, 'i'))
        )
      : []
    const array = regionsFiltered.map(region => ({
      value: region.squareBounds,
      label: region.name
    }))

    return fetchAddressAutocomplete(array, input)
  }

  handleChange = categoryOption => {
    this.setState({ category: categoryOption })
  }

  onChange = value => {
    this.setState({ query: value })
  }

  handleSubmit = e => {
    e.preventDefault()
    if (this.state.query) {
      if (this.state.query.value.length === 4) {
        const jsonBounds = this.state.query.value.map(bound => ({
          lat: bound[0],
          lng: bound[1]
        }))
        this.props.history.push(
          `${routes.recherche}?category=${getUrlValueFromValue(
            this.state.category.value
          )}&page=1&bounds=${encodeBase64(JSON.stringify(jsonBounds))}`
        )
      } else if (this.state.query.value.length === 2) {
        this.props.history.push(
          `${routes.recherche}?category=${getUrlValueFromValue(
            this.state.category.value
          )}&coordinates=${this.state.query.value}`
        )
      }
    } else if (this.state.category.value !== 'all') {
      this.props.history.push(
        `${routes.recherche}?category=${getUrlValueFromValue(
          this.state.category.value
        )}&page=1&bounds=${encodeBase64(boundsFranceStringified)}`
      )
    }
  }

  toggleSearchBar = () => {
    this.setState({ showSearchBar: !this.state.showSearchBar })
  }

  render() {
    const { classes, resultatsRecherche } = this.props
    return (
      <Row className={classes.rawRes}>
        <Col xs={1}>
          <div className={classes.divFiltre}>
            <Filtre
              taille={20}
              onClick={() => this.toggleSearchBar()}
              className={classes.filtre}
            />
          </div>
        </Col>
        {!this.state.showSearchBar ? (
          resultatsRecherche && (
            <Col xs={10}>
              <p className={classes.texteResultats}>
                {resultatsRecherche.nbRes} résultats pour votre recherche
              </p>
            </Col>
          )
        ) : (
          <Form inline className={classes.form}>
            <FormGroup className={classes.formGroup}>
              <Select
                instanceId='mobile-1'
                className={classes.categories}
                classNamePrefix='categories'
                value={this.state.category}
                onChange={this.handleChange}
                name='categories'
                options={categoriesOptions}
                isClearable={false}
                isSearchable={false}
                components={{ IndicatorSeparator: () => <div /> }}
              />
            </FormGroup>
            <FormGroup className={classes.formGroup}>
              <Async
                instanceId='mobile-2'
                name='autocomplete-region-address'
                defaultOptions
                value={this.state.query}
                onChange={this.onChange}
                loadOptions={this.getOptions}
                placeholder='Votre ville ou adresse'
                isClearable={false}
                isMulti={false}
                components={{ IndicatorsContainer: () => <div /> }}
                className={classes.autocomplete}
                classNamePrefix='address'
              />
              <FormControl.Feedback>
                <Marqueur className={classes.marqueur} />
              </FormControl.Feedback>
            </FormGroup>
            <div className={classes.divButton}>
              <ButtonStyle
                className={classes.button}
                onClick={this.handleSubmit}
              >
                Rechercher
              </ButtonStyle>
            </div>
          </Form>
        )}
      </Row>
    )
  }
}

const gqlRegions = gql`
  {
    regions {
      name
      squareBounds
    }
  }
`

const StyledTopBar = injectSheet(styles)(SearchBarMobile)
const RouterTopBar = withRouter(StyledTopBar)

export default graphql(gqlRegions)(RouterTopBar)
